import reservioDark from './icons/dark.svg';
import reservioWhite from './icons/white.svg';

export const ICONS = {
    reservioDark,
    reservioWhite,
};
